import {ref, reactive, watch} from "vue";
import {useStorage} from '@vueuse/core'
import helpers from "@/lib/helpers";

export function useDataTable(id, url, params, perPage, sortBy) {
    params = params || {};


    const tableData = useStorage(id + '-table', {
        url,
        currentPage: 1,
        sortBy,
        sortDesc: false,
        filter: null,
        perPage,
    }, sessionStorage)

    if (tableData.value.url !== url) {
        tableData.value.url = url
        tableData.value.currentPage = 1
        tableData.value.sortBy = sortBy
        tableData.value.sortDesc = false
        tableData.value.perPage = perPage
    }

    const tableRecords = ref()
    const tableProps = reactive({
        items: null,
        sortBy: tableData.value.sortBy,
        sortDesc: tableData.value.sortDesc,
        noLocalSorting: true
    })

    const tableFilter = ref(tableData.value.filter)

    const tableRefresh = async () => {
        const results = await helpers.asyncAction(url, 'GET', {
            params: {
                q: tableData.value.filter,
                ...params,
                page: tableData.value.currentPage,
                length: tableData.value.perPage,
                sortBy: tableData.value.sortBy,
                sortDesc: tableData.value.sortDesc ? 1 : 0,
            }
        })
        tableProps.items = results.data
        tableRecords.value = results.records
    }

    watch(params, tableRefresh, {deep: true});
    watch(tableData, tableRefresh, {immediate: true, deep: true})

    const tableUpdate = (ctx) => {
        if (ctx.sortBy !== undefined)
            tableData.value.sortBy = ctx.sortBy

        if (ctx.sortDesc !== undefined)
            tableData.value.sortDesc = ctx.sortDesc

        if (ctx.filter !== undefined) {
            tableData.value.currentPage = 1
            tableData.value.filter = ctx.filter
        }

    }

    return {
        tableProps,
        tableData,
        tableRecords,
        tableRefresh,
        tableUpdate,
        tableFilter
    }
}